/** Hub library book list keys (hub_library.books JSON). */

export const HUB_WORK_ORDERS_BOOK_LIST = "workOrders" as const;

/** Legacy API/list key; normalised to {@link HUB_WORK_ORDERS_BOOK_LIST}. */
export const HUB_WORK_BOOK_LIST_LEGACY = "work" as const;

export function normalizeHubBookList(list: string): string {
	if (list === HUB_WORK_BOOK_LIST_LEGACY) return HUB_WORK_ORDERS_BOOK_LIST;
	return list;
}
